import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { SearchProductToProductsRecommendationsFragmentDoc } from '@packages/gql/generated/shopping/SearchProductToProductsRecommendationsFragmentDoc';
import { SearchProductToProductsRecoSlider } from '@packages/recommendations/src/components/ProductsRecoSliders/SearchProductToProductsRecoSlider';
import { useIntl } from 'react-intl';
import { searchProductToProductsFallbackHeadline } from './messages';

/* GraphQL */ `
  fragment SearchProductToProductsRecommendations on Product {
    promotion
    orderNumber
  }
`;

export type SearchProductToProductsRecommendationsProps = {
  /**
   * The data from the product query needed for the `SearchProductToProductsRecoSlider` comnponent.
   */
  data: FragmentType<typeof SearchProductToProductsRecommendationsFragmentDoc>;
};

/**
 * This component is a wrapper for the `SearchProductToProductsRecoSlider` component.
 * It encapsulates the data from the product query needed for the `SearchProductToProductsRecoSlider` component and passes correct props.
 */
export const SearchProductToProductsRecommendations = ({
  data,
}: SearchProductToProductsRecommendationsProps) => {
  const { orderNumber, promotion } = getFragmentData(
    SearchProductToProductsRecommendationsFragmentDoc,
    data,
  );
  const { formatMessage } = useIntl();

  return (
    <SearchProductToProductsRecoSlider
      productId={`${orderNumber}${promotion}`}
      elementIndex={0}
      fetchOnThreshold
      pageTemplate="detailview"
      title={formatMessage(searchProductToProductsFallbackHeadline)}
      key={`${orderNumber}${0}`}
    />
  );
};
